// frontend/admin-portal/src/components/dashboard/RecentOrdersTable.jsx
import React from "react";
import {
  Table,
  Badge,
  Alert,
  formatMoney,
  Button,
  Panel,
} from "@fiberhome/shared-ui";
import { useNavigate } from "react-router-dom";

const STATUS_VARIANT = {
  draft: "default",
  pending: "warning",
  accepted: "primary",
  fulfilled: "success",
  rejected: "danger",
  cancelled: "default",
};

export default function RecentOrdersTable({ slice, onViewAll }) {
  const navigate = useNavigate();
  const { data, loading, error } = slice;

  return (
    <Panel
      title="Recent Orders"
      subtitle="Last 5 placed"
      tone="info"
      actions={
        <Button variant="ghost" size="sm" onClick={onViewAll}>
          View all →
        </Button>
      }
    >
      {error && <Alert variant="danger">{error}</Alert>}
      <Table
        columns={[
          {
            key: "code",
            label: "Code",
            render: (r) => (
              <span style={{ fontFamily: "monospace", fontSize: 12 }}>
                {r.code}
              </span>
            ),
          },
          {
            key: "customer",
            label: "Customer",
            render: (r) => r.customer?.name || "—",
          },
          {
            key: "total",
            label: "Total",
            render: (r) => (
              <span style={{ fontWeight: 600 }}>
                {formatMoney(r.total, { symbol: r.currency || "USD" })}
              </span>
            ),
          },
          {
            key: "status",
            label: "Status",
            render: (r) => (
              <Badge variant={STATUS_VARIANT[r.status] || "default"}>
                {r.status}
              </Badge>
            ),
          },
          {
            key: "createdAt",
            label: "Placed",
            render: (r) =>
              new Date(r.createdAt).toLocaleDateString(undefined, {
                month: "short",
                day: "numeric",
              }),
          },
        ]}
        data={data}
        loading={loading}
        emptyMessage="No orders yet"
        rowKey="id"
        onRowClick={(r) => navigate(`/orders/${r.id}`)}
      />
    </Panel>
  );
}
